import ARROW_UP_RIGHT from './src/arrow-up-right.svg'
import BALANCE from './src/balance.svg'
import OFFICE_USE from './src/office-use.svg'
import SETTINGS_ALERT from './src/settings-alert.svg'
import SETTINGS_FORM_COMPLETE_PAGE from './src/settings-form-complete.svg'
import SETTINGS_GENERAL from './src/settings-general.svg'
import SETTINGS_INVITATION from './src/settings-invitation.svg'
import SETTINGS_NOTIFICATION from './src/settings-notification.svg'

const IconSources = {
  ARROW_UP_RIGHT,
  BALANCE,
  OFFICE_USE,
  SETTINGS_ALERT,
  SETTINGS_FORM_COMPLETE_PAGE,
  SETTINGS_GENERAL,
  SETTINGS_INVITATION,
  SETTINGS_NOTIFICATION,
}

export default IconSources
